import { render } from "./ChangeTipDocument.vue?vue&type=template&id=0eb5d9c2&ts=true"
import script from "./ChangeTipDocument.ts?vue&type=script&lang=ts&external"
export * from "./ChangeTipDocument.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QBtn});
